import { Component, ElementRef, HostListener, inject, Input, OnInit, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


interface Provider {
  cm: string;
  st: string;
}

interface ApiResponse {
  providers: Provider[];
}

@Component({
  selector: 'app-search-dropdown',
  standalone: false,
  templateUrl: './search-dropdown.component.html',
  styleUrl: './search-dropdown.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchDropdownComponent),
      multi: true
    }
  ]
})

export class SearchDropdownComponent implements OnInit {
  private http = inject(HttpClient);
  private elementRef = inject(ElementRef);

  @Input() fileUrl: string = '';
  @Input() rootKey: string = '';
  @Input() displayKey: string = '';
  @Input() filterKeys: any[] = [];
  
  @Input() defaultValue: any = null;
  // @Input() filterKeys: string = '';
  @Input() filterValues: { [key: string]: any } = {};
  
  // @Input() filterValues: string = ''
  @Input() placeholder: string = 'Select an Option'

  // Estados
  items: any[] = [];
  filteredItems: any[] = [];
  searchTerm: string = '';
  selectedItem: any = null;
  isOpen: boolean = false;

  dynamicFilterKeys: string[] = [];
  dynamicFilterValues: { [key: string]: any } = [];

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  async ngOnInit() {

    this.parseConfigs();
    await this.loadData();

    this.selectDedaultItem(this.defaultValue);
  }

  writeValue(obj: any): void {
    this.selectedItem = obj;
    
    if (obj && this.displayKey) {
      this.searchTerm = obj[this.displayKey];
    } else {
      this.searchTerm = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private parseConfigs() {
    try {
      const filterConfig = this.filterKeys
      if (filterConfig && Array.isArray(filterConfig)) {
        this.dynamicFilterKeys = filterConfig;
      }
      
      const filterValues = this.filterValues;

      this.dynamicFilterValues = Object.values(filterValues).map(v => String(v));
      
    } catch (e) {
      console.error('Error parseando configuraciones:', e);
    }
  }

  private async loadData() {
    try {
      const rawData = await firstValueFrom(this.http.get(this.fileUrl, { responseType: 'text' }));
      const cleanJson = rawData.replace(/,\s*([\]}])/g, '$1');
      const jsonData = JSON.parse(cleanJson);
      const rawList = this.rootKey ? jsonData[this.rootKey] : jsonData;
      
      if (Array.isArray(rawList)) {
        this.items = rawList.filter(item => {          
          for (let i = 0; i < this.dynamicFilterKeys.length; i++) {
            const keyToCheck = this.dynamicFilterKeys[i];
            const valueToMatch = this.filterValues[keyToCheck];

            // console.log(`Chequeando: Key=${keyToCheck}, Valor a buscar=${valueToMatch}, Valor en item=${item[keyToCheck]}`);

            if (valueToMatch === undefined) continue;

            if (item[keyToCheck] !== valueToMatch) {
              return false;
            }
          }
          return true;
        });
      }

      this.filteredItems = [...this.items];
    } catch (error) {
      console.error('Error cargando datos:', error);
    }
  }

  filterList() {
    const term = this.searchTerm.toLowerCase();
    if (!term) {
      this.filteredItems = [...this.items];
    } else {
      this.filteredItems = this.items.filter(item => {
        const displayValue = item[this.displayKey];
        return displayValue && String(displayValue).toLowerCase().includes(term);
      });
    }
    this.isOpen = true;
  }

  selectItem(item: any) {
    this.selectedItem = item;
    this.searchTerm = item;
    this.isOpen = false;    
    this.onChange(item); 
    this.onTouched();
  }

  selectDedaultItem(item: any){
    this.selectedItem = item;
    this.searchTerm = item;
    this.isOpen = false;    
    this.onChange(item); 
    this.onTouched();
   }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) this.filterList();
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    } else {
    }
  }
}
